export default "__VITE_ASSET__W55xoXeX__"